//使用history的好处是可以在任意位置获取到browser的path
import { createBrowserHistory } from "history";
export let history = createBrowserHistory({ basename: "" });

//注意 使用这个版本v5有bug，不能路径跳转 history@4.10.1